export default class Header {
    constructor() {
        console.log('%c👍🏼 Header', 'color: yellow');
    }
    init() {
        const headerDark = document.querySelector('.header-dark');
        const header = document.querySelector('header');
        const navbar = header.querySelector('.navbar');  
        const dropdowns = header.querySelectorAll('.dropdown-toggle')
        const dropdownsToo = header.querySelectorAll('.dropdown-item--secondary')  

        if(headerDark) {
            const img = header.querySelector('.navbar-brand img');
            img.src = header.dataset.logo;
            header.classList.add('header-dark');
        }

        dropdowns.forEach((elem) => {

            elem.addEventListener('show.bs.dropdown', function () {

                if (window.matchMedia("(min-width: 992px)").matches) {
                    if(elem.id != 'navbarDropdownMenuLinkLang') {
                        navbar.classList.add('navbar--open');
                    }    
                }
              });
        
              elem.addEventListener('hide.bs.dropdown', function () {
                navbar.classList.remove('navbar--open');
              });

            //aria-expand-true on desktop 
            elem.addEventListener('click', function (e) {
                if (window.matchMedia("(max-width: 992px)").matches) {

                    let el = this.nextElementSibling;
                    el.style.display = el.style.display==='block'?'none':'block'
                }
            })
        })

        dropdownsToo.forEach((elem) => {

            //aria-expand-true on desktop 

            elem.addEventListener('click', function (e) {
                if (window.matchMedia("(max-width: 992px)").matches) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    let el = this.closest('.dropdown');
                    let toggle = el.querySelector('.dropdown-toggle');
                    toggle.classList.add('show');
                }
            })
        })


        function addLanguagePrefix() {
            // Get the current pathname
            var currentPath = window.location.pathname;
        
            // Check if the current pathname already contains /es/
            if (currentPath.indexOf("/es/") === -1) {
                // If /es/ is not present, add it
                var newPath = "/es" + currentPath;
        
                // Create the new URL
                return window.location.protocol + "//" + window.location.hostname + newPath;
        
                // Redirect to the new URL
                // window.location.href = newURL;
            } else {
                return window.location.protocol + "//" + window.location.hostname + currentPath.replace('/es/', '/');
            }
        }

       const currentUrl = addLanguagePrefix();
       const checkLink = async url => (await fetch(url)).ok;

        checkLink( currentUrl)
          .then(isValid => {
            if (isValid) {
                const langEl = header.querySelector('.dropdown-item--lang');
                langEl.href = currentUrl;
            } 
          });
    }
}